import { render } from "./Prime.view.vue?vue&type=template&id=4582c390"
import script from "./Prime.view.vue?vue&type=script&lang=js"
export * from "./Prime.view.vue?vue&type=script&lang=js"

import "./Prime.view.vue?vue&type=style&index=0&id=4582c390&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__